export default __webpack_public_path__ + "static/media/user-icon.08fd7854.svg";